import { render, staticRenderFns } from "./CompanySelection.vue?vue&type=template&id=6cb6bac2&scoped=true&"
import script from "./CompanySelection.vue?vue&type=script&lang=ts&"
export * from "./CompanySelection.vue?vue&type=script&lang=ts&"
import style0 from "./CompanySelection.vue?vue&type=style&index=0&id=6cb6bac2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb6bac2",
  null
  
)

export default component.exports